export const ACTIONS = {
  RESET_ADDRESS: 'resetAddress',
  RESET_INPUT_STATE: 'resetInputState',
  RESET_TEMPLATE_AND_PROJECT_TYPE: 'resetTemplateAndProjectType',
  SET_ADDRESS: 'setAddress',
  SET_ADDRESS_INPUT_MODE: 'setAddressInputMode',
  SET_AUTOCOMPLETED_ADDRESS: 'setAutocompletedAddress',
  SET_CURRENCY: 'setCurrency',
  SET_END_DATE: 'setEndDate',
  SET_IS_SAVING: 'setIsSaving',
  SET_JOB_NUMBER: 'setJobNumber',
  SET_MISSING_REQUIRED_FIELD: 'setMissingRequiredField',
  SET_MAPBOX_TOKEN_ACTIVE: 'setMapboxTokenActive',
  SET_PHASE: 'setPhase',
  SET_PROJECT_NAME: 'setProjectName',
  SET_PROJECT_VALUE: 'setProjectValue',
  SET_SELECTED_ACCOUNT: 'setSelectedAccount',
  SET_SELECTED_PROJECT_TYPE: 'setSelectedProjectType',
  SET_SELECTED_TEMPLATE: 'setSelectedTemplate',
  SET_SHOW_DUPLICATED_NAME_ERROR: 'setShowDuplicatedNameError',
  SET_SHOW_INVALID_PROJECT_VALUE_ERROR: 'setShowInvalidProjectValueError',
  SET_SHOW_MODAL_CONFIRMATION: 'setShowModalConfirmation',
  SET_START_DATE: 'setStartDate',
  SET_TIME_ZONE: 'setTimeZone',
};
